import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap";
// Formik validation
import * as Yup from "yup";
import { useFormik, Formik } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { DataNew, updateClient } from "../../store/actions";
import { countrieList } from "constants/CountryDropDown";
import Select, { createFilter } from "react-select";
import { useParams } from 'react-router-dom';
import PageLoader from '../../components/Common/PageLoader';
import { clientFormResetFieldTouched } from "constants/ResetFormField";
import client_info from '../../assets/images/svg/client/client-info.svg'
import kyc from '../../assets/images/svg/client/kyc-details.svg'
import { Country, State, City } from "country-state-city";

const Client = props => {
  let { id } = useParams();
  const [userData, setUserData] = useState(null)
  document.title = `${!id ? "Add New Client" : "Update Client"} | Glottis Logistics`;
  const [selectedGroup, setselectedGroup] = useState(null);
  const [stateValue, setstateValue] = useState(null);
  const [countryListValue, setCountryListValue] = useState([{ label: 'Select country', value: '' }, ...countrieList]);
  const [statelistvalue, setstatelistvalue] = useState(null);
  const [citylistvalue, setcitylistvalue] = useState(null);
  const [cityValue, setcityValue] = useState(null);
  const dispatch = useDispatch();

  // Form validation 
  const clientForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      clientCode: '',
      name: '',
      email: '',
      phone: '',
      address_1: '',
      address_2: '',
      country: '',
      state: '',
      city: '',
      postalCode: '',
      pan: '',
      tan: '',
      gst: ''
    },

    validationSchema: Yup.object({
      clientCode: Yup.string().required("Enter client code").max(12, 'Client code should not exceed 12 characters'),
      name: Yup.string().required("Enter company name").max(50, 'Company name should not exceed 50 characters'),
      email: Yup.string().required("Enter email").max(30, 'Email should not exceed 30 characters').email("Enter valid email"),
      phone: Yup.string().required("Enter phone number").max(15, 'Phone number should not exceed 15 characters'),
      address_1: Yup.string().required("Enter house.no / building.no").max(15, 'House.no / building.no should not exceed 15 characters'),
      address_2: Yup.string().required("Enter street address").max(75, 'Street address should not exceed 75 characters'),
      country: Yup.string().required("Select country"),
      state: Yup.string().required("Select state"),
      city: Yup.string().required("Enter city").max(30, 'City should not exceed 30 characters'),
      postalCode: Yup.string().required("Enter postal code").max(10, 'Postal code should not exceed 10 characters'),
      pan: Yup.string().required("Enter PAN number").min(10, 'PAN number should be 10 digits').max(10, 'PAN number should be 10 digits'),
      tan: Yup.string().required("Enter TAN number").min(10, 'TAN number should be 10 digits').max(10, 'TAN number should be 10 digits'),
      gst: Yup.string().required("Enter GST number").min(15, 'GST number should be 15 digits').max(15, 'GST number should be 15 digits'),
    }),
    onSubmit: (values) => {
      if (id) {
        dispatch(DataNew(values, props.history, id));
      } else {
        dispatch(DataNew(values, props.history));
      }
    },
  });

  const getUserData = () => {
    dispatch(updateClient(id))
  }

  const { client, loading } = useSelector(state => ({
    client: state.AddClient01.user,
    loading: state.AddClient01.loader, 
   }))

  useEffect(() => {
    if (id) {
      getUserData();
    }
  }, [id])

  useEffect(() => {
    setUserData(client);
  }, [client])

  function setCountryValue(country) {
    const value = { label: country, value: country }
    setselectedGroup(value);
    clientForm.setFieldValue("country", country);
    setstateValue(null)
    setcityValue(null)
  }

  const countries = Country.getAllCountries(); 
  const states = State.getAllStates();
  useEffect(() => {
    let filterCountry;
    let stateList;
    if (clientForm.values.country !== '') {
      filterCountry = countries.filter(function (country) {
        return country.name.toLowerCase() === clientForm.values.country.toLowerCase();
      })
    }
    if(filterCountry){
      stateList = states.filter((state) => state.countryCode === filterCountry[0].isoCode).map((state) => ({ label: state.name, value: state.name }))
      setstatelistvalue([{ label: "Select state", value: '' }, ...stateList])
    }else {
      setstatelistvalue([{ label: 'Please select country first', value: '' }])
    }
  }, [clientForm.values.country])
  
  function setstate(state) {
    const value = { label: state, value: state }
    setstateValue(value);
    clientForm.setFieldValue("state", state);
    setcityValue(null)
  }

  const cities = City.getAllCities();
  useEffect(() => {
    let filterState;
    let cityList;
    if (clientForm.values.country !== '') {
      filterState = states.filter(function (state) {
        return state.name.toLowerCase() === clientForm.values.state.toLowerCase();
      })
    }
    if(filterState){
      cityList = cities.filter((city) => (city?.countryCode === filterState[0]?.countryCode) && (city.stateCode === filterState[0].isoCode)).map((city) => ({ label: city.name, value: city.name }))
      setcitylistvalue([{ label: 'Select city', value: '' }, ...cityList])
    }else {
      setcitylistvalue([{ label: 'Please select state first', value: '' }])
    }
  }, [clientForm.values.state])

  function setCity(city) {
    const value = { label: city, value: city }
    setcityValue(value);
    clientForm.setFieldValue("city", city);
  }

  useEffect(() => {
    setClientFormValues()
  }, [userData])

  const setClientFormValues = () => {
    if (id && client) {
      clientForm.setFieldValue("clientCode", client.clientCode);
      clientForm.setFieldValue("name", client.name);
      clientForm.setFieldValue("email", client.email);
      clientForm.setFieldValue("phone", client.phone);
      clientForm.setFieldValue("address_1", client.address_1);
      clientForm.setFieldValue("address_2", client.address_2);
      setCountryValue(client.country);
      setstate(client.state);
      setCity(client.city);
      clientForm.setFieldValue("postalCode", client.postalCode);
      clientForm.setFieldValue("pan", client.pan ? client.pan : '');
      clientForm.setFieldValue("tan", client.tan ? client.tan : '');
      clientForm.setFieldValue("gst", client.gst ? client.gst : '');
    }
  } 
 
  return (
    <React.Fragment>  
      {loading ? <PageLoader /> : ""}
        <div className="page-content client">
          <Container fluid={true}>
            <Breadcrumbs title="Clients" dashurl="/clients" breadcrumbItem={!id ? "Add New Client" : "Update Client"} />
            <Row className="add-client">
              <Col xl="12">

                <Form className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    clientForm.handleSubmit();
                    return false;
                  }}
                >
                  <Card>
                    <CardBody>
                      <div className='avater d-flex'>
                        <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                          <img src={client_info} alt="" />
                        </div>
                        <p className='f-size-16 fw-600 mb-0'>Client information</p>
                      </div>
                      <Row>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Client code <span>*</span></Label>
                            <Input
                              name="clientCode"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.clientCode || ""}
                              invalid={
                                clientForm.touched.clientCode && clientForm.errors.clientCode ? true : false
                              }
                            />
                            {clientForm.touched.clientCode && clientForm.errors.clientCode ? (
                              <FormFeedback type="invalid">{clientForm.errors.clientCode}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Company name <span>*</span></Label>
                            <Input
                              name="name"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.name || ""}
                              invalid={
                                clientForm.touched.name && clientForm.errors.name ? true : false
                              }
                            />
                            {clientForm.touched.name && clientForm.errors.name ? (
                              <FormFeedback type="invalid">{clientForm.errors.name}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Company email <span>*</span></Label>
                            <Input
                              name="email"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.email || ""}
                              invalid={
                                clientForm.touched.email && clientForm.errors.email ? true : false
                              }
                            />
                            {clientForm.touched.email && clientForm.errors.email ? (
                              <FormFeedback type="invalid">{clientForm.errors.email}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>House.no / Building.no<span>*</span></Label>
                            <Input
                              name="address_1"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.address_1 || ""}
                              invalid={
                                clientForm.touched.address_1 && clientForm.errors.address_1 ? true : false
                              }
                            />
                            {clientForm.touched.address_1 && clientForm.errors.address_1 ? (
                              <FormFeedback type="invalid">{clientForm.errors.address_1}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="8">
                          <FormGroup className="mb-3">
                            <Label>Street address<span>*</span></Label>
                            <Input
                              name="address_2"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.address_2}
                              invalid={
                                clientForm.touched.address_2 && clientForm.errors.address_2 ? true : false
                              }
                            />
                            {clientForm.touched.address_2 && clientForm.errors.address_2 ? (
                              <FormFeedback type="invalid">{clientForm.errors.address_2}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Country <span>*</span></Label>
                          <div className={`position-relative drop-down ${clientForm.touched.country && clientForm.errors.country ? 'role' : ''}`}>
                            <Select
                              options={countryListValue}
                              className='form-control'
                              search={true}
                              name="country"
                              filterOption={createFilter({matchFrom : 'start'})}
                              value={selectedGroup}
                              placeholder={`Select country`}
                              onChange={(value) => {
                                setCountryValue(value.value);
                              }}
                            />
                          </div> 
                            {clientForm.touched.country && clientForm.errors.country ? (
                              <span className="role-error invalid-feedback">{clientForm.errors.country}</span>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>State <span>*</span></Label>
                            <div className={`position-relative drop-down ${clientForm.touched.state && clientForm.errors.state ? 'role' : ''}`}>
                            <Select
                              options={statelistvalue}
                              className={`form-control ${!clientForm.values.country? 'no-drop-list': ''}`}
                              search={true} 
                              name="state"
                              filterOption={createFilter({matchFrom : 'start'})}
                              value={stateValue}
                              placeholder={`Select state`}
                              onChange={(value) => {
                                setstate(value.value);
                              }}
                            />
                          </div> 
                            {clientForm.touched.state && clientForm.errors.state ? (
                              <span className="role-error invalid-feedback">{clientForm.errors.state}</span>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>City <span>*</span></Label>
                            <div className={`position-relative drop-down ${clientForm.touched.city && clientForm.errors.city ? 'role' : ''}`}>
                            <Select
                              options={citylistvalue}
                              className={`form-control ${!clientForm.values.state? 'no-drop-list': ''}`}
                              search={true} 
                              name="city"
                              filterOption={createFilter({matchFrom : 'start'})}
                              value={cityValue}
                              placeholder={`Select city`}
                              onChange={(value) => {
                                setCity(value.value);
                              }}
                            />
                          </div> 
                            {clientForm.touched.city && clientForm.errors.city ? (
                              <span className="role-error invalid-feedback">{clientForm.errors.city}</span>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Postal code <span>*</span></Label>
                            <Input
                              name="postalCode"
                              type="text"
                              className="form-control"
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.postalCode || ""}
                              invalid={
                                clientForm.touched.postalCode && clientForm.errors.postalCode ? true : false
                              }
                            />
                            {clientForm.touched.postalCode && clientForm.errors.postalCode ? (
                              <FormFeedback type="invalid">{clientForm.errors.postalCode}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Company phone number<span>*</span></Label>
                            <Input
                              name="phone"
                              onWheel={(e) => e.target.blur()}
                              type='number'
                              className="form-control"
                              id=""
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.phone || ""}
                              invalid={
                                clientForm.touched.phone && clientForm.errors.phone ? true : false
                              }
                            />
                            {clientForm.touched.phone && clientForm.errors.phone ? (
                              <FormFeedback type="invalid">{clientForm.errors.phone}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>

                      </Row>
                    </CardBody >
                  </Card >
                  <Card>
                    <CardBody>
                      <div className='avater d-flex'>
                        <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                        <img src={kyc} alt="" />
                        </div>
                        <p className='f-size-16 fw-600 mb-0'>KYC details</p>
                      </div>
                      <Row>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>GST number<span>*</span></Label>
                            <Input
                              name="gst"
                              type='text'
                              className="form-control text-uppercase"
                              id=""
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.gst || ""}
                              invalid={
                                clientForm.touched.gst && clientForm.errors.gst ? true : false
                              }
                            />
                            {clientForm.touched.gst && clientForm.errors.gst ? (
                              <FormFeedback type="invalid">{clientForm.errors.gst}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>PAN number<span>*</span></Label>
                            <Input
                              name="pan"
                              type='text'
                              className="form-control text-uppercase"
                              id=""
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.pan || ""}
                              invalid={
                                clientForm.touched.pan && clientForm.errors.pan ? true : false
                              }
                            />
                            {clientForm.touched.pan && clientForm.errors.pan ? (
                              <FormFeedback type="invalid">{clientForm.errors.pan}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>TAN number<span>*</span></Label>
                            <Input
                              name="tan"
                              type='text'
                              className="form-control text-uppercase"
                              id=""
                              onChange={clientForm.handleChange}
                              onBlur={clientForm.handleBlur}
                              value={clientForm.values.tan || ""}
                              invalid={
                                clientForm.touched.tan && clientForm.errors.tan ? true : false
                              }
                            />
                            {clientForm.touched.tan && clientForm.errors.tan ? (
                              <FormFeedback type="invalid">{clientForm.errors.tan}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody >
                  </Card >
                  <div className="mb-30">
                    <button className="primary-button" type="submit">
                      Save
                    </button>
                    <button type="reset" onClick={() => {
                      if (id) {
                        setClientFormValues()
                        clientFormResetFieldTouched(false, clientForm)
                      }
                      else {
                        clientForm.resetForm()
                        setselectedGroup(null)
                        setstateValue(null)
                        setcityValue(null)
                      }
                    }}
                      className="ms-4 secountry-btn">
                      Clear
                    </button>
                  </div>
                </Form >
              </Col >
            </Row >
          </Container >
        </div >
  
    </React.Fragment >
  );
};

export default Client;
